import appConfig from '@nerdwallet/app-config';
import getEnvCompatibleAppConfig from '../../../env/get-env-compatible-app-config';
var config = getEnvCompatibleAppConfig(appConfig);
window.nerdwallet = window.nerdwallet || {};
window.nerdwallet.config = window.nerdwallet.config || {};
window.nerdwallet.config[process.env.CLIENT_ID] = window.nerdwallet.config[process.env.CLIENT_ID] || {};

window.nerdwallet.config[process.env.CLIENT_ID].get = function (key, fallback) {
  return config[key] !== undefined ? config[key] : fallback;
};

window.nerdwallet.config[process.env.CLIENT_ID].all = config;